import { useQuery } from '@tanstack/react-query';
import { fetchShipmentBranchList } from '../data-provider/shipment-branch';
import type { ShipmentBranchRequestParams } from '../data-provider/shipment-branch/api';

export const useGetShipmentBranchList = (params: ShipmentBranchRequestParams) => {
  return useQuery({
    queryKey: ['shipment-branch-list', params.Customerkey],
    queryFn: () => fetchShipmentBranchList(params),
    staleTime: 1000 * 60 * 15, // 15 min
    enabled: !!params.Customerkey,
  });
};
